export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Razón de espera\",\n    \"label_plural\": \"{{count}} razones de espera\"\n}\n"